import React, { Component } from 'react'
import OnBoardingContainer from '../sections/OnBoardingContainer'
class OnBoardingPage extends Component {

    constructor(props, context) {
        super()
    }

    render() {
        let search = window.location.search
        let params = new URLSearchParams(search)
        let continueParam = params.get('continue')

        return <OnBoardingContainer
            routeStep={this.props.match ? this.props.match.params.stepId : ''}
            continue={continueParam}
        />
    }
}

export default OnBoardingPage


// WEBPACK FOOTER //
// ./src/onboarding/pages/OnBoardingPage.jsx